export default __webpack_public_path__ + "static/media/Clock_Hand_Hour.6a1d2040.svg";